import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const INCIDENT_CARD_SIZE = '15rem';

export const useStyles = makeStyles()(theme => ({
  noIncidentsText: {
    marginBottom: '3rem',

    '& span': {
      fontWeight: 'bold',
      color: theme.palette.success.main,
      fontSize: '1.7rem',
    }
  },

  number: {
    fontSize: '4rem',
  },

  daysWithoutIncidentstext: {
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
}));
